import { dwsCanceledComponent } from './canceled.component';

export const dwsCanceledStateName = 'app.ticket.dwsReceivingCanceled';

export const dwsCanceledState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: dwsCanceledStateName,
    url: '/dwsCanceled',
    component: dwsCanceledComponent.name,
    data: { requiresAuth: true },
  });
};
